module.exports = __webpack_public_path__ + "img/12-banner.0e985f15.png";